
























import {Vue, Component, Prop} from 'vue-property-decorator';
import * as util from '@/util/utils';
import LetterAttachmentMobile from '@/components/MobileComponents/LetterDetailsMobile/LetterAttachmentMobile/LetterAttachmentMobile.vue';
import File from '../../../../../../store/models/Letter/File';
@Component({
    components: {LetterAttachmentMobile}
})
export default class LetterTrailNodeCommentMobile extends Vue{
    @Prop() mode?: string;
    @Prop() sendTime?: string;
    @Prop() comment?: string;
    @Prop() incomingLetterNumberReferenceNumber?: string;
    @Prop() letterNo?: string;
    @Prop() attachments?: File[];
    get formattedTime(){
        if(!this.sendTime) return '';
        return util.getPersianFullFormatDate(this.sendTime);
    }

    get type(){
        switch(this.mode){
            case 'send': return 'ارسال';
            case 'forward': return 'ارجاع';
            case 'close': return 'اختتام';
            default: return '';
        }
        
    }

    get label(){
        switch(this.mode){
            case 'send': return 'هامش:';
            case 'forward': return 'هامش:';
            case 'close': return 'توضیحات:';
            default: return '';
        }
    }
}   
